import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { useUserDetails } from "../../../context/auth";
import BASEURL from "../../Utils/Baseurl";
import axios from "axios";
import { object } from "prop-types";

function AttendanceTable() {
  const {
    totaldays,
    fromdate,
    enddate,
    allyears,
    allmonth,
    shifts,
    employee,
    loaction,
    department,
    AccessData,
  } = useUserDetails();

  const [attendanceData, setAttendanceData] = useState([]);
  const [availableLeaveTypes, setAvailableLeaveTypes] = useState([]);
  let year = allyears.value;
  let month = allmonth.value + 1;
  const depart = department;
  const userDetails = sessionStorage.getItem("user");
  const parsedData = JSON.parse(userDetails);
  const encodedId = btoa(parsedData?.id);
  const getAttendanceData = async () => {
    let startDate = fromdate || new Date().toISOString().split("T")[0];
    let endDate =
      enddate ||
      new Date(new Date().setDate(new Date().getDate() + 30))
        .toISOString()
        .split("T")[0];
    let empid = employee?.value || "";
    let department = depart?.value || "";
    let shift = shifts?.value || "";
    const managerQuery = AccessData?.some(
      (item) =>
        item.module === "Attendance" &&
        item.component === "ManagerAttendance" &&
        item.can_access
    );
    const hrQuery = AccessData?.some(
      (item) =>
        item.module === "Attendance" &&
        item.component === "HRAttendance" && 
        item.can_access
    );

    if(!managerQuery && !hrQuery) {
      console.error("No access to Manager or HR Attendance data");
      return;
    };

    const query =
     (managerQuery && !hrQuery)
        ? `query overallAttendance_BY_TeamleaderID(
  $teamleader: String!,
  $month: Int,
  $year: Int,
  $startDate: Date,
  $endDate: Date,
  $department: String,
  $shift: String,
  $empid: String
) {
  managerAttendance(
    teamleader: $teamleader,
    month: $month,
    year: $year,
    startDate: $startDate,
    endDate: $endDate,
    department: $department,
    shift: $shift,
    empid: $empid
  ) {
    data{
    user {
      id
      empid
        firstName
      lastName
    }
    checkIn
    checkOut
    totalWorkingHours
    overtime
  }
  }
  managerLeave(
    teamleader: $teamleader,
    month: $month,
    year: $year,
    startDate: $startDate,
    endDate: $endDate,
    department: $department,
    shift: $shift,
    empid: $empid
  ) {
    data{
    user {
      id
      empid  
        firstName
      lastName
    }
    leaveType {
				name
    }
    leaveFrom
    leaveTill
    totalDays
    reason
    status
  }
  }
  totalPresentDays(
    teamleader: $teamleader,
    month: $month,
    year: $year,
    startDate: $startDate,
    endDate: $endDate,
    department: $department,
    shift: $shift,
    empid: $empid
  ) {
    data
    success
    error
    message
  }
  totalLeaveDaysByType(
    teamleader: $teamleader,
    month: $month,
    year: $year,
    startDate: $startDate,
    endDate: $endDate,
    department: $department,
    shift: $shift,
    empid: $empid
  ) {
    leaveType
    leaveCount
    totalDays
  }
}
    `
        : `
   query ManagerAttendanceData(
  $teamleader: String,
  $month: Int,
  $year: Int,
  $start_date: Date,
  $end_date: Date,
  $department: String,
  $shift: String,
  $empid: String
) {
  managerAttendanceAll(
    teamleader: $teamleader,
    month: $month,
    year: $year,
    startDate: $start_date,
    endDate: $end_date,
    department: $department,
    shift: $shift,
    empid: $empid
  ) {
    data{
     id
    user {
       id
      empid
      firstName
      lastName
    }
    checkIn
    checkOut
    totalWorkingHours,
    overtime
  }
  }
  totalPresentDaysAll(
    teamleader: $teamleader,
    month: $month,
    year: $year,
    startDate: $start_date,
    endDate: $end_date,
    department: $department,
    shift: $shift,
    empid: $empid
  ) {
    totalPresentDays
    success
    error
    message
  }
  managerLeaveAll(
    teamleader: $teamleader,
    month: $month,
    year: $year,
    startDate: $start_date,
    endDate: $end_date,
    department: $department,
    shift: $shift,
    empid: $empid
  ) {
    data{
    id
    user {
       id
      empid
      firstName
      lastName
    }
    leaveType {
      name
    }
    leaveFrom
    leaveTill
    totalDays
    status
  }
  }
  totalLeaveDaysByTypeAll(
    teamleader: $teamleader,
    month: $month,
    year: $year,
    startDate: $start_date,
    endDate: $end_date,
    department: $department,
    shift: $shift,
    empid: $empid
  ) {
    leaveType
    leaveCount
    totalDays
  }
}
    `;
    try {
      if (managerQuery && !hrQuery) {
        const response = await axios.post(
          BASEURL,
          {
            query: query,
            variables: {
              teamleader: parsedData.id,
              month,
              year,
              startDate,
              endDate,
              department,
              empid,
              shift,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const managerAttendance = response.data.data.managerAttendance.data;
        console.log(managerAttendance, "manageraatt");

        const managerLeave = response.data.data.managerLeave.data;

        const leaveTypes = response.data.data.totalLeaveDaysByType
          .map((type) => type.leaveType)
          .filter((name) => name !== "Total Days Leave")
          .sort();

        console.log(response.data.data.totalLeaveDaysByType, "ltypess");
        console.log(managerAttendance, "manageratt");

        setAvailableLeaveTypes(leaveTypes);

        // Group attendance data by user ID
        const groupedData =
          Array.isArray(managerAttendance) &&
          managerAttendance.reduce((acc, item) => {
            const userId = item.user.id;
            const userName = item.user.firstName;
            if (!acc[userId]) {
              acc[userId] = {
                id: userId,
                empid: item?.user?.empid,
                name: item.user.firstName,

                leaveCounts: {},
                totalLeaves: 0,
                overtime: 0,
                days: new Array(totaldays).fill(""),
              };
            }

            if (item.overtime) {
              const [hours, minutes] = item.overtime.split(":").map(Number);
              const overtimeMinutes = hours * 60 + minutes;
              acc[userId].overtime += overtimeMinutes;
            }

            const checkInDate = new Date(item.checkIn);
            const checkOutDate = new Date(item.checkOut);
            const checkInDay = checkInDate.getDate() - 1;

            if (
              checkInDate &&
              // checkOutDate &&
              // checkOutDate > checkInDate &&
              checkInDay < totaldays
            ) {
              const ot =
                item.overtime && item.overtime !== "0:00"
                  ? ` + ${item.overtime}`
                  : "";
              acc[userId].days[checkInDay] = `P${ot}`;
            }

            return acc;
          }, {});

        Object.values(groupedData).forEach((user) => {
          if (user.overtime > 0) {
            const hours = Math.floor(user.overtime / 60);
            const minutes = user.overtime % 60;
            user.overtime = `${hours}:${minutes.toString().padStart(2, "0")}`;
          } else {
            user.overtime = "0:00";
          }
        });
        // Process leave data and update groupedData with leave counts and marked days
        console.log(managerLeave, "mleaveee");

        managerLeave.forEach((leave) => {
          const userId = leave.user.id;
          const username = leave.user.firstName;
          const empid = leave.user.empid;
          const leaveType = leave.leaveType?.name;
          const leaveFrom = new Date(leave.leaveFrom);
          const leaveTill = new Date(leave.leaveTill);
          const isPending =
            // leave.status === "Pending" || leave.status == "rejected";
            leave.status === "Pending";

          if (!groupedData[userId]) {
            groupedData[userId] = {
              id: userId,
              name: username,
              empid: empid,
              leaveCounts: {},
              totalLeaves: 0,
              days: new Array(totaldays).fill(""),
            };
          }

          if (!groupedData[userId].leaveCounts[leaveType]) {
            groupedData[userId].leaveCounts[leaveType] = 0;
          }
          const totalDays = isNaN(parseFloat(leave.totalDays))
            ? 0
            : parseFloat(leave.totalDays);
          if (!isPending) {
            groupedData[userId].leaveCounts[leaveType] += totalDays;
            groupedData[userId].totalLeaves += totalDays;
          }

          // if (!isPending) {
          //   groupedData[userId].leaveCounts[leaveType] += leave.totalDays;
          //   groupedData[userId].totalLeaves += leave.totalDays;
          // }
          console.log(
            "Total Days:",
            leave.totalDays,
            "Type:",
            typeof leave.totalDays
          );

          // Mark leave days only if they are not already marked as Present
          for (
            let date = leaveFrom;
            date <= leaveTill;
            date.setDate(date.getDate() + 1)
          ) {
            const leaveDay = date.getDate() - 1;
            if (
              leaveDay < totaldays &&
              groupedData[userId].days[leaveDay] !== "P"
            ) {
              groupedData[userId].days[leaveDay] = {
                type: leaveType,
                isPending,
              };
            }
          }
        });
        console.log(Object.values(groupedData), "grdata");

        setAttendanceData(Object.values(groupedData));
      } else {
        if ((startDate, endDate, month, year)) {
          const response = await axios.post(
            BASEURL,
            {
              query: query,
              variables: {
                month,
                year,
                startDate,
                endDate,
                department,
                empid,
                shift,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          const datas = response?.data?.data;
          const managerAttendance = datas?.managerAttendanceAll?.data || [];
          const managerLeave = datas?.managerLeaveAll?.data || [];

          // const holidays = (datas?.holidayDetailsAll || []).map((h) =>
          //   JSON.parse(h)
          // );
          // const weekoffData = (datas?.weekoffDetailsAll || []).map((entry) =>
          //   JSON.parse(entry)
          // );
          const leaveTypes = (datas?.totalLeaveDaysByTypeAll || [])
            .map((type) => type.leaveType)
            .filter((type) => type !== "Total Days Leave");

          setAvailableLeaveTypes(leaveTypes);
          let groupedData = {};
          // Step 1: Process Present Attendance
          managerAttendance.forEach((item) => {
            const userId = item.user?.id;
            const username = item.user?.firstName;
            if (!userId || !username) return;

            if (!groupedData[userId]) {
              groupedData[userId] = {
                id: userId,
                name: username,
                empid: item.user.empid,
                leaveCounts: {},
                totalLeaves: 0,
                overtime: 0,
                days: new Array(totaldays).fill(""),
              };
            }

            // Handle overtime
            if (item.overtime) {
              const [hours, minutes] = item.overtime.split(":").map(Number);
              groupedData[userId].overtime += hours * 60 + minutes;
            }

            const checkInDay = new Date(item.checkIn).getDate() - 1;

            if (checkInDay >= 0 && checkInDay < totaldays) {
              const ot =
                item.overtime && item.overtime !== "0:00"
                  ? ` + ${item.overtime}`
                  : "";
              groupedData[userId].days[checkInDay] = `P${ot}`;
            }
          });

          // Convert overtime minutes to HH:MM format
          Object.values(groupedData).forEach((user) => {
            const hours = Math.floor(user.overtime / 60);
            const minutes = user.overtime % 60;
            user.overtime = `${hours}:${minutes.toString().padStart(2, "0")}`;
          });

          // Step 2: Process Leaves (only if not already marked as Present)
          managerLeave.forEach((leave) => {
            const userId = leave.user?.id;
            const username = leave.user?.firstName;
            if (!userId || !username) return;

            if (!groupedData[userId]) {
              groupedData[userId] = {
                id: userId,
                name: username,
                empid: leave.user.empid,
                leaveCounts: {},
                totalLeaves: 0,
                overtime: 0,
                days: new Array(totaldays).fill(""),
              };
            }

            const leaveType = leave.leaveType?.name || "Unknown";
            const isPending = leave.status === "Pending";
            const leaveFrom = new Date(leave.leaveFrom);
            const leaveTill = new Date(leave.leaveTill);

            if (!groupedData[userId].leaveCounts[leaveType]) {
              groupedData[userId].leaveCounts[leaveType] = 0;
            }

            if (!isPending) {
              groupedData[userId].leaveCounts[leaveType] += leave.totalDays;
              groupedData[userId].totalLeaves += leave.totalDays;
            }

            for (
              let date = new Date(leaveFrom);
              date <= leaveTill;
              date.setDate(date.getDate() + 1)
            ) {
              const dayIndex = date.getDate() - 1;
              if (dayIndex >= 0 && dayIndex < totaldays) {
                const currentValue = groupedData[userId].days[dayIndex];
                // Don't overwrite Present
                if (
                  typeof currentValue !== "string" ||
                  !currentValue.startsWith("P")
                ) {
                  groupedData[userId].days[dayIndex] = {
                    type: leaveType,
                    isPending,
                  };
                }
              }
            }
          });
          setAttendanceData(Object.values(groupedData));
          console.log(groupedData, "groupedData");
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getStatusColor = (status, isPending) => {
    if (isPending) {
      return "#616161"; // Gray color for pending leave
    }

    switch (status) {
      case "P":
        return "#4CAF50";
      case "casual_leave":
        return "#FFB74D";
      case "sick_leave":
        return "#4FC3F7";
      case "earned_leave":
        return "#81C784";
      case "loss_of_pay":
        return "#E57373";
      case "privilege_leave":
        return "#9575CD";
      case "annual_leave":
        return "#FF8A65";
      case "maternity_leave":
        return "#FF4E88";
      case "paternity_leave":
        return "#B1C29E";
      case "restricted_holiday":
        return "#FCF596";

      default:
        if (typeof status === "string" && status.startsWith("P")) {
          return "#4CAF50"; // Or any other color for statuses starting with 'P'
        }
        return "white";
    }
  };

  const leavetypes = (leave, isPending) => {
    if (isPending) {
      switch (leave) {
        case "earned_leave":
          return "EL";
        case "casual_leave":
          return "CL*";
        case "sick_leave":
          return "SL*";
        case "loss_of_pay":
          return "LP*";
        case "annual_leave":
          return "AL";
        case "privilege_leave":
          return "PL";
        case "maternity_leave":
          return "ML";
        case "paternity_leave":
          return "PA";
        case "restricted_holiday":
          return "RH";
        default:
          return `${leave}`;
      }
    }
    if (!isPending) {
      switch (leave) {
        case "earned_leave":
          return "EL";
        case "casual_leave":
          return "CL";
        case "sick_leave":
          return "SL";
        case "loss_of_pay":
          return "LP";
        case "annual_leave":
          return "AL";
        case "privilege_leave":
          return "PL";
        case "maternity_leave":
          return "ML";
        case "paternity_leave":
          return "PA";
        case "restricted_holiday":
          return "RH";
        case "P":
          return "P";
        default:
          return `${leave}`;
      }
    }
  };

  useEffect(() => {
    getAttendanceData();
  }, [totaldays, fromdate, month, year, enddate, department, employee, shifts]);
  return (
    <div
      style={{
        zIndex: 1,
      }}
    >
      <Box
        sx={{
          maxHeight: "600px", // Set the maximum height for vertical scrolling
          overflowY: "auto", // Enable vertical scrolling
          overflowX: "auto",
          "&::-webkit-scrollbar": {
            width: "8px",
            height: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#888",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#555",
          },
        }}
      >
        <Table stickyHeader>
          {/* <Typography style={{ marginLeft: "2%" }}>Attendance Data</Typography> */}
          <TableHead>
            <TableRow>
              <TableCell>Emp ID</TableCell>
              <TableCell>Name</TableCell>
              {availableLeaveTypes.map((leaveType) => (
                <TableCell key={leaveType}>{leavetypes(leaveType)}</TableCell>
              ))}
              <TableCell align="center">Total Leaves</TableCell>
              <TableCell align="center">Total OT </TableCell>
              {console.log([...Array(totaldays).keys()], "alldatta")}
              {[...Array(totaldays).keys()].map((day) => (
                <TableCell key={day} align="center">
                  {day + 1}
                </TableCell>
              ))}
            </TableRow>

            <TableBody>
              {attendanceData.map((row) => {
                console.log(row);
                return (
                  <TableRow key={row.id}>
                    <TableCell>{row.empid}</TableCell>
                    <TableCell>{row.name}</TableCell>

                    {availableLeaveTypes.map((leaveType) => (
                      <TableCell key={leaveType}>
                        {row.leaveCounts[leaveType] || 0}
                      </TableCell>
                    ))}
                    <TableCell align="center">{row.totalLeaves}</TableCell>
                    <TableCell>{row?.overtime}</TableCell>
                    {row.days.map((day, index) => {
                      const status = day?.type || day;
                      const isPending = day?.isPending || false;
                      return (
                        <TableCell
                          key={index}
                          align="center"
                          style={{
                            backgroundColor: getStatusColor(status, isPending),
                            color: "white",
                            width: "200px",
                            height: "80px",
                          }}
                        >
                          {leavetypes(status, isPending) || ""}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </TableHead>
        </Table>
      </Box>
      <Box
        mt={2}
        display="flex"
        justifyContent="center"
        gap={2}
        flexWrap="wrap"
      >
        {[
          { label: "Present (P)", color: "#4CAF50" },
          { label: "Casual Leave (CL)", color: "#FFB74D" },
          { label: "Sick Leave (SL)", color: "#4FC3F7" },
          { label: "Privilege Leave (PL)", color: "#9575CD" },
          { label: "Earned Leave (EL)", color: "#81C784" },
          { label: "Loss of Pay (LP)", color: "#E57373" },
          { label: "Annual Leave(AL)", color: "#FF8A65" },
          { label: "Paternity Leave(PAL)", color: "#B1C29E" },
          { label: "Restricted Holiday(RH)", color: "#FCF596" },
          { label: "Maternity Leave(ML)", color: "#FF4E88" },
          { label: "Unapproved", color: "#616161" },
        ].map((legend) => (
          <Box key={legend.label} display="flex" alignItems="center">
            <Box width={16} height={16} bgcolor={legend.color} mr={1} />
            <Typography variant="body2">{legend.label}</Typography>
          </Box>
        ))}
      </Box>
    </div>
  );
}

export default AttendanceTable;
